import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import CheckListIntervention from './CheckListIntervention';
import './RechercherPlanning.css';  // Import the CSS file
import { jwtDecode } from 'jwt-decode';
import Footer from './Footer';
import * as XLSX from 'xlsx'; // Import de la bibliothèque xlsx
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const PlanningList = () => {
  const [devices, setDevices] = useState([]);
  const [editingDevice, setEditingDevice] = useState(null);
  const [detailsDevice, setDetailsDevice] = useState(null);
  const formRef = useRef(null); // Reference for the form
  const detailsRef = useRef(null); // Reference for the details
  const [typeUser, setTypeUser] = useState('');
  const [progress, setProgress] = useState(0); // State for progress percentage
  const today = new Date().toISOString().split('T')[0];
  const [endDate, setEndDate] = useState(today); // End date
  // États pour les champs de recherche
  const [searchTermNumero, setSearchTermNumero] = useState('');
  const [searchTermDesignation, setSearchTermDesignation] = useState('');
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [searchTermLocalisation, setSearchTermLocalisation] = useState('');
  const [selectedForPdf, setSelectedForPdf] = useState([]);
  const [organesParDevice, setOrganesParDevice] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
        if (endDate) {
          fetchDevices();
          fetchOperations(); // Ensure fetchOperations is called after the dates change
        }
        checkUserType();
    }, [endDate]); // Trigger when endDate changes

  useEffect(() => {
    if (editingDevice && formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [editingDevice]);

  useEffect(() => {
    if (detailsDevice && detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [detailsDevice]);

  // Utilisation de l'effet pour filtrer en fonction des deux critères de recherche
  useEffect(() => {
      const filtered = devices.filter((device) =>
        device.device_name.toLowerCase().includes(searchTermDesignation.toLowerCase()) &&
        device.numero_inventaire.toLowerCase().includes(searchTermNumero.toLowerCase()) &&
        device.equipement_localisation.toLowerCase().includes(searchTermLocalisation.toLowerCase())
      );
      setFilteredDevices(filtered);
      setSelectedForPdf(filtered.map(device => device.id));
  }, [searchTermNumero, searchTermDesignation, searchTermLocalisation, devices]);

  const fetchDevices = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/devices`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (Array.isArray(response.data)) {
          const filteredDevices = response.data.filter(device => {
                      if (!device.date_prochain_vidange) {
                                        // Exclure les appareils avec une date_prochain_vidange null ou vide
                                        return false;
                      }
                      const prochainVidangeDate = new Date(device.date_prochain_vidange);
                      const end = new Date(endDate);
                      // Vérifier si la date est valide
                      if (isNaN(prochainVidangeDate)) {
                                        return false; // Exclure les appareils avec une date invalide
                      }
                      return prochainVidangeDate <= end;
          });
          // Sort devices by ordre_passage
          const sortedDevices = filteredDevices.sort((a, b) => a.ordre_passage - b.ordre_passage);
          setDevices(sortedDevices);
          setFilteredDevices(sortedDevices); // Initialize filteredDevices with all devices

          // Compter le nombre d'éléments dans sortedDevices
                const deviceCount = sortedDevices.length;
                console.log('Nombre d\'appareils:', deviceCount);
                // Fetch operations and calculate progress
                fetchOperations(deviceCount);

        } else {
          console.error('Response data is not an array: ', response.data);
          setDevices([]);
        }
      } catch (error) {
        console.error('Error fetching devices: ', error);
        setDevices([]);
      }
    };

        const fetchOperations = async (deviceCount) => {
          const token = localStorage.getItem('token');
          try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/operationvidange`, {
              headers: { Authorization: `Bearer ${token}` }
            });

            if (Array.isArray(response.data)) {
              const todayOperations = response.data.filter(operation => {
              {/*if (!operation.date_operationVidange) {
                                // Exclure les opérations avec une date null ou vide
                                return false;
              }*/}
                        const operationDate = new Date(operation.date_operationVidange).toISOString().split('T')[0];
                        const end = new Date(endDate).toISOString().split('T')[0];
                        {/*if (isNaN(operationDate)) {
                                              return false; // Exclure les opérations avec une date invalide
                        }*/}
                        return operationDate <= end;
              });

              // Compter le nombre d'éléments dans sortedDevices
              const opCount = todayOperations.length;
              console.log('Nombre d\'operations:', opCount);
              // Calculate progress percentage
              const progressPercentage = deviceCount > 0 ? (opCount / ( deviceCount + opCount ) ) * 100 : 0;
              setProgress(progressPercentage);
            } else {
              console.error('Response data is not an array: ', response.data);
            }
          } catch (error) {
            console.error('Error fetching operations: ', error);
          }
        };



  const checkUserType = () => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setTypeUser(decodedToken.typeUser);
    }
  };

  const handleEdit = (device) => {
    setEditingDevice(device);
  };

  const handleDetails = (device) => {
    setDetailsDevice(device);
  };

  const handleCancel = () => {
      setEditingDevice(null);
  };

  const handleFormSubmit = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Défilement en haut de la page
    setEditingDevice(null);
    fetchDevices();
    fetchOperations();
  };

  // Fonction d'exportation en CSV
      const exportToCSV = () => {
        if (devices.length === 0) {
          alert('Aucun appareil à exporter.');
          return;
        }

        const headers = [
          'Date',
          'N° inventaire',
          'Désignation',
          'Localisation',
          'Étage',
          'Ordre de passage',
          // Ajoutez d'autres champs si nécessaire
        ];

        const rows = devices.map(device => [
          device.date_prochain_vidange
            ? new Date(device.date_prochain_vidange).toLocaleDateString('fr-FR')
            : 'NA',
          device.numero_inventaire,
          device.device_name,
          device.equipement_localisation,
          device.etage,
          device.ordre_passage,
          // Ajoutez d'autres champs si nécessaire
        ]);

        const csvContent =
          'data:text/csv;charset=utf-8,' +
          [headers.join(','), ...rows.map(e => e.join(','))].join('\n');

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        const today = new Date().toISOString().split('T')[0];
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `planning_du_jour_${today}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      // Fonction d'exportation en Excel
      const exportToExcel = () => {
        if (devices.length === 0) {
          alert('Aucun appareil à exporter.');
          return;
        }

        const data = devices.map(device => ({
          'Date': device.date_prochain_vidange
            ? new Date(device.date_prochain_vidange).toLocaleDateString('fr-FR')
            : 'NA',
          'N° inventaire': device.numero_inventaire,
          'Désignation': device.device_name,
          'Localisation': device.equipement_localisation,
          'Étage': device.etage,
          'Ordre de passage': device.ordre_passage,
          // Ajoutez d'autres champs si nécessaire
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Planning du jour');

        XLSX.writeFile(workbook, `planning_du_jour_${new Date().toISOString().split('T')[0]}.xlsx`);
      };

      const filterDevices = () => {
              const filtered = devices.filter(device => {
                return (
                  device.device_name.toLowerCase().includes(searchTermDesignation.toLowerCase()) &&
                  device.numero_inventaire.toLowerCase().includes(searchTermNumero.toLowerCase())
                );
              });
              setFilteredDevices(filtered);
      };



          const fetchOrganesForSelectedDevices = async (selectedDeviceIds) => {
            const token = localStorage.getItem('token');
            const organesMap = {};

            for (const deviceId of selectedDeviceIds) {
              const device = filteredDevices.find(d => d.id === deviceId);
              if (!device || !device.numero_inventaire) continue;

              try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/organes/${device.numero_inventaire}`, {
                  headers: { Authorization: `Bearer ${token}` }
                });
                organesMap[device.id] = Array.isArray(response.data) ? response.data : [];
              } catch {
                organesMap[device.id] = [];
              }
            }

            return organesMap;
          };

        const generatePDF = async (organesData) => {
          const selectedDevices = filteredDevices.filter(d => selectedForPdf.includes(d.id));
          const logo = new Image();
          logo.src = `${window.location.origin}/logo.png`;

          await new Promise((resolve) => { logo.onload = resolve; });

          const doc = new jsPDF();

          selectedDevices.forEach((device, index) => {
            if (index !== 0) doc.addPage();
            doc.addImage(logo, 'PNG', 15, 10, 30, 20);
            doc.setFontSize(16);
            doc.text(`FICHE D'INTERVENTION`, 105, 20, { align: 'center' });
            doc.setFontSize(10);
            let y = 35;

            const equipmentDetails = [
              ['N° inventaire', device.numero_inventaire],
              ['Désignation', device.device_name],
              ['Localisation', device.equipement_localisation],
              ['Étage', device.etage],
              ['Ordre de passage', device.ordre_passage],
              ['Échéance de visite', device.date_prochain_graissage ? new Date(device.date_prochain_graissage).toLocaleDateString() : 'NA'],
              ['Périodicité', device.grease_period],
              ['Type de contrôle', device.niveau],
              ['Réf Graisse', device.designation_grade_graisse],
              ['Réf Huile', device.designation_grade_huile],
              ['Quantité huile', device.huile_quantity],
              ['Gamme', device.gamme],
              ['Commentaire', device.observation]
            ];

            doc.autoTable({
              startY: y,
              head: [],
              body: equipmentDetails.map(row => row.map(cell => cell || 'NA')),
              theme: 'grid',
              styles: { fontSize: 10, cellPadding: 3 },
              columnStyles: { 0: { fontStyle: 'bold', cellWidth: 60 }, 1: { cellWidth: 120 } },
              margin: { left: 15, right: 15 }
            });

            y = doc.lastAutoTable.finalY + 10;
            doc.text('Compte rendu:', 15, y); y += 6;
            for (let i = 0; i < 5; i++) doc.line(15, y + i * 8, 195, y + i * 8);
            y += 40;
            doc.text('Signaler anomalie:', 15, y); y += 6;
            for (let i = 0; i < 5; i++) doc.line(15, y + i * 8, 195, y + i * 8);

            const organes = organesData[device.id] || [];
            if (organes.length > 0) {
              y += 50;
              doc.text('N.B : Organes liés à l’équipement ci-joint :', 15, y);
              y += 5;

              doc.autoTable({
                startY: y,
                head: [['Nom', 'Réf. Huile', 'Réf. Graisse', 'Qté Huile (L)', 'Qté Graisse (CP)', 'Gamme']],
                body: organes.map(org => [
                  org.nom || 'NA',
                  org.huile || 'NA',
                  org.graisse || 'NA',
                  org.huileOrganeQuantite || 'NA',
                  org.graisseOrganeQuantite || 'NA',
                  org.gamme_organe || 'NA'
                ]),
                theme: 'grid',
                styles: { fontSize: 8 },
                margin: { left: 15, right: 15 }
              });
            }
          });

          doc.save('fiches_intervention.pdf');
        };

  return (
    <div>
      <Navbar />

      <h2>Rechercher un planning</h2>

            <div className="date-filter">
<div className="date-input-container">
              <label>
                Planning jusqu'au :
                <input class="date-field" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </label>
    </div>

            </div>
            <div className="recherche"><input
                                  type="text"
                                  placeholder="Rechercher par numéro d'inventaire"
                                  value={searchTermNumero}
                                  onChange={(e) => setSearchTermNumero(e.target.value)}
                                /></div>
                                <div className="recherche"><input
                                  type="text"
                                  placeholder="Rechercher par désignation"
                                  value={searchTermDesignation}
                                  onChange={(e) => setSearchTermDesignation(e.target.value)}
                                /></div>
    <div className="recherche">
      <input
        type="text"
        placeholder="Rechercher par localisation"
        value={searchTermLocalisation}
        onChange={(e) => setSearchTermLocalisation(e.target.value)}
      />
    </div>


      {/* Affiche la table uniquement si editingDevice est null */}
      {!editingDevice && !detailsDevice && (
      <div>

      <div className="export-buttons">
                                <div className="colExcel"><button onClick={exportToCSV}>Exporter en CSV</button></div>
                                <div className="colExcel"><button onClick={exportToExcel}>Exporter en Excel</button></div>
                                <div className="colExcel"><button onClick={() => setShowModal(true)}>Fiches d'intervention</button></div>
      </div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Date</th>
            <th>N° inventaire</th>
            <th>Désignation</th>
            <th>Localisation</th>
            <th>Etage</th>
            <th>Ordre de passage</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredDevices.map((device) => (
            <tr key={device.id}>
              <td className="abc"><img src={device.photo} className="device-photo" /></td>
              <td className="abc">{new Date(device.date_prochain_vidange).toLocaleDateString('fr-FR')}</td>
              <td className="abc">{device.numero_inventaire}</td>
              <td className="abc">{device.device_name}</td>
              <td className="abc">{device.equipement_localisation}</td>
              <td className="abc">{device.etage}</td>
              <td className="abc">{device.ordre_passage}</td>
              <td className="actions-cell" className="abc">
                <button onClick={() => handleEdit(device)}>Intervention vidange</button>
                {/*<button onClick={() => handleDetails(device)}>Fiche équipement</button>*/}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

                {showModal && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h3>Sélectionner les équipements à imprimer</h3>
                      {filteredDevices.length === 0 ? (
                                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                                      <p style={{ color: 'red', fontStyle: 'italic' }}>
                                                        ⚠️ Aucun équipement dans le planning.
                                                      </p>
                                                      <div className="modal-buttons">
                                                        <button onClick={() => setShowModal(false)}>Fermer</button>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <>
                      <table>
                        <thead>
                          <tr><th>Sélection</th><th>N° inventaire</th><th>Désignation</th></tr>
                        </thead>
                        <tbody>
                          {filteredDevices.map(device => (
                            <tr key={device.id}>
                              <td>
                                <input type="checkbox" checked={selectedForPdf.includes(device.id)} onChange={() => {
                                  setSelectedForPdf(prev =>
                                    prev.includes(device.id)
                                      ? prev.filter(id => id !== device.id)
                                      : [...prev, device.id]
                                  );
                                }} />
                              </td>
                              <td>{device.numero_inventaire}</td>
                              <td>{device.device_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className="modal-buttons">
                        <button onClick={async () => {
                          const organesData = await fetchOrganesForSelectedDevices(selectedForPdf);
                          generatePDF(organesData);
                        }}>Télécharger PDF</button>

                        {/*<button onClick={async () => {
                          const organesData = await fetchOrganesForSelectedDevices(selectedForPdf);
                          generatePDF(organesData);
                          setTimeout(() => window.print(), 500);
                        }}>Imprimer</button>*/}

                        <button onClick={() => setShowModal(false)}>Fermer</button>
                      </div>
                      </>
                     )}
                    </div>
                  </div>
                )}


      </div>
      )}
      {editingDevice && (
        <div ref={formRef}>
          <CheckListIntervention
            device={editingDevice}
            onSubmit={handleFormSubmit}
            onCancel={handleCancel}
            showNavbar={false} // Passez false pour masquer la Navbar
          />
        </div>
      )}
      {detailsDevice && (
        <div ref={detailsRef} className="details-card">
          <h3>Fiche équipement</h3>
          <div className="ContainrColumns">
                     <div className="col">
                          {detailsDevice.photo && (
                               <div className="photo-container">
                               <img src={detailsDevice.photo} alt="Photo de l'équipement" className="device-photo" />
                               </div>
                          )}
                     </div>

                     <div className="col">
                                          <p><strong>Numéro d inventaire :</strong> {detailsDevice.numero_inventaire || 'NA'}</p>
                                          <p><strong>Désignation :</strong> {detailsDevice.device_name || 'NA'}</p>
                                          <p><strong>Localisation :</strong> {detailsDevice.equipement_localisation || 'NA'}</p>
                                          <p><strong>Etage :</strong> {detailsDevice.etage || 'NA'}</p>
                                          <p><strong>Ordre de passage :</strong> {detailsDevice.ordre_passage || 'NA'}</p>
                     </div>

                     <div className="col">
                                          <p>
                                            <strong>Echéance de visite :</strong>
                                            <span
                                              style={{
                                                color: detailsDevice.date_prochain_vidange && new Date(detailsDevice.date_prochain_vidange) <= new Date() ? 'red' : 'black'
                                              }}>
                                              {detailsDevice.date_prochain_vidange ? new Date(detailsDevice.date_prochain_vidange).toLocaleDateString() : 'NA'}
                                            </span>
                                          </p>
                                          <p><strong>Fréquence de visite :</strong> {detailsDevice.grease_period || 'NA'}</p>
                                          <p><strong>Type de controle :</strong> {detailsDevice.niveau || 'NA'}</p>
                                          <p><strong>Réf Graisse :</strong> {detailsDevice.designation_grade_graisse || 'NA'} <strong> - Réf Huile :</strong> {detailsDevice.designation_grade_huile || 'NA'}</p>
                     </div>

                     <div className="col">
                                          <p><strong>Quantité huile (L) :</strong> {detailsDevice.grease_quantity || 'NA'} <strong> - Type organe :</strong> {detailsDevice.type_organe || 'NA'}</p>
                                          <p><strong>Gamme :</strong> {detailsDevice.gamme || 'NA'}</p>
                                          <p><strong>Commentaire :</strong> {detailsDevice.observation || 'NA'}</p>
                     </div>
                  </div>


                  <div className="colB">
                  <div className="colC">
                  <button onClick={() => setDetailsDevice(null)}>Fermer</button>
                  </div>
                  </div>

        </div>
      )}
    </div>
  );
};

export default PlanningList;
